import React from 'react';

const GenreFilter = ({ genres, selectedGenre, onGenreChange }) => {
    return (
        <div className="flex justify-center mb-6">
            <div className="relative w-full max-w-xl">
                <select
                    value={selectedGenre}
                    onChange={onGenreChange}
                    className="w-full appearance-none py-4 px-6 bg-[#141414] text-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e50914] shadow-md"
                >
                    <option value="">All Genres</option>
                    {genres.map(genre => (
                        <option key={genre.id} value={genre.id}>
                            {genre.name}
                        </option>
                    ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-white">
                    <svg className="fill-current h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default GenreFilter; 